
// Waits until the element matching the given CSS selector is present in the DOM,
// then resolves with that element. Uses MutationObserver to detect late-rendered elements.
export const elementLoadedInDOM = async (selector) => {
    return await new Promise((resolve) => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }
        const observer = new MutationObserver(() => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });
        observer.observe(document.body, {
            childList: true,
            subtree:true,
        });
    });
};
